import * as React from 'react'

export const ScreenshotEditorView = (props) => {
  const {
    activeType,
    changeType,
    onSave,
    onCancel,
    onUndo,
    editorRef,
    canvasRef,
    toolbarRef,
    toolbarDragRef,
    toolbarPosition,
  } = props

  return (
    <div className="editor" ref={editorRef}>
      <canvas ref={canvasRef} width="400" height="300" />
      <div className="toolbar" style={toolbarPosition} ref={toolbarRef} id="toolbar">
        <div className="toolbar-drag" ref={toolbarDragRef}>
          ...
          <br />
          ...
        </div>

        <div className="toolbar-items">
          <div className={`toolbar-item ${activeType === 'backdrop' ? 'active' : ''}`} onClick={_ => changeType('backdrop')}>
            <div className="backdrop"></div>
          </div>

          <div className={`toolbar-item ${activeType === 'filledRectang' ? 'active' : ''}`} onClick={_ => changeType('filledRectang')}>
            <div className="rect"></div>
          </div>

          <div className={`toolbar-item ${activeType === 'filledLine' ? 'active' : ''}`} onClick={_ => changeType('filledLine')}>
            <div className="line"></div>
          </div>

          <div className={`toolbar-item ${activeType === 'filledArrow' ? 'active' : ''}`} onClick={_ => changeType('filledArrow')}>
            <div className="arrow"></div>
          </div>

          <div className={`toolbar-item ${activeType === 'text' ? 'active' : ''}`} onClick={_ => changeType('text')}>
            <div className="text">A</div>
          </div>

          <div className={`toolbar-item ${activeType === 'resize' ? 'active' : ''}`} onClick={_ => changeType('resize')}>
            <div className="resize"></div>
          </div>

          <div className="toolbar-btn undo" onClick={onUndo}>
            <svg width="24" height="24" color="default" viewBox="0 0 24 24" cursor="pointer">
              <path d="M12.3885 8.66666C10.1802 8.66666 8.18016 9.49166 6.63849 10.8333L5.06349 9.25832C4.53849 8.73332 3.63849 9.09999 3.63849 9.84166V14.5C3.63849 14.9583 4.01349 15.3333 4.47182 15.3333H9.13016C9.87182 15.3333 10.2468 14.4333 9.72182 13.9083L8.13016 12.3167C9.28849 11.35 10.7635 10.75 12.3968 10.75C15.0302 10.75 17.3052 12.2833 18.3885 14.5C18.6135 14.9667 19.1468 15.2 19.6385 15.0333C20.2302 14.8417 20.5302 14.1667 20.2635 13.6C18.8302 10.6833 15.8468 8.66666 12.3885 8.66666Z"></path>
            </svg>
          </div>
        </div>

        <div className="toolbar-btns">
          <div className="toolbar-btn save" onClick={onSave}>
            <svg width="24" height="24" color="default" viewBox="0 0 24 24" cursor="pointer">
              <path d="M9.1925 16.1925L5.6925 12.6925C5.50765 12.5053 5.25555 12.4 4.9925 12.4C4.72945 12.4 4.47735 12.5053 4.2925 12.6925C3.9025 13.0825 3.9025 13.7025 4.2925 14.0925L8.4825 18.2825C8.8725 18.6725 9.5025 18.6725 9.8925 18.2825L20.4925 7.69248C20.8825 7.30248 20.8825 6.68248 20.4925 6.29248C20.3076 6.10533 20.0555 6 19.7925 6C19.5294 6 19.2774 6.10533 19.0925 6.29248L9.1925 16.1925Z"></path>
            </svg>
          </div>

          <div className="toolbar-btn cancel" onClick={onCancel}>
            <svg width="24px" height="24px" cursor="inherit" viewBox="0 0 24 24">
              <path d="M15.3079036,16.7054786 L12.0024972,13.401223 L8.69209639,16.7094721 C8.30553128,17.0968426 7.67723811,17.0968426 7.29067299,16.7094721 C6.903109,16.3231 6.903109,15.6961188 7.29067299,15.3087483 L10.6000749,11.9995008 L7.29067299,8.69125172 C6.903109,8.30388119 6.903109,7.67690004 7.29067299,7.29052789 C7.67723811,6.90315737 8.30553128,6.90315737 8.69209639,7.29052789 L12.0024972,10.598777 L15.3079036,7.2945214 C15.6944687,6.90715088 16.321763,6.90715088 16.709327,7.2945214 C17.0958921,7.68189193 17.0958921,8.30887308 16.709327,8.69524523 L13.4039206,12.0004992 L16.709327,15.3047548 C17.096891,15.6911269 17.096891,16.3191065 16.709327,16.7054786 C16.3227619,17.0918507 15.6944687,17.0918507 15.3079036,16.7054786 Z"></path>
            </svg>
          </div>
        </div>

      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/ScreenshotEditor.js